<template>

  <PageLoader v-if="loading"/>
  <div v-if="currentBudget" class="row"> 
    <div class="col-md-3">
        <Card class="bg-primary p-8 mb-5">
            <div class="d-flex align-items-center justify-content-between mb-2" >
                <span class=" fs-1 text-white">{{$t("budgets.balance")}}({{ currentBudget.name }})</span>
                <span>
                    <i class="fs-1 text-white fas fa-coins"></i>
                </span>
            </div>
            <div class="text-white display-5 fw-bold">{{formattedLocalAmount(currentBudget.balance) }} {{ currencyIso }}</div>
            <div class="separator mt-3 mb-5"></div>
            <div class="d-flex justify-content-between align-items-center gap-5">
                <a v-if="$can(abilities.PROJECT_BUDGET_DEPOSIT)" class="btn btn-white w-100 text-primary font-weight-bold  text-center btn-block" @click="openDepositModal">{{ $t('budgets.deposit') }}</a>
                <a v-if="$can(abilities.PROJECT_BUDGET_WITHDRAWAL)" class="btn btn-white w-100 text-primary font-weight-bold text-center btn-block" @click="openWithdrawalModal">{{ $t('budgets.withdrawal') }}</a>
            </div>
        </Card>
        <Card class="mb-5 p-5" >
          <Card class="bg-light-primary p-5 " @click="query.project_category_step_id = ''">
            <div class="fs-1 text-center text-primary">{{$t("budgets.name")}}</div>
            <div class="text-primary text-center display-5 fw-bold">{{formattedLocalAmount(currentBudget.forecast_budget) }} {{ currencyIso }}</div>
          </Card>
          <div class="mt-5" v-if="currentBudget?.allow_dispatch">
            <div class="mt-3" v-if="!mustDispactch && currentBudget?.allow_dispatch">
              <h3>{{ $t('budgets.byStep') }}</h3>
              <div class="">
                <BudgetStepCard v-for="step in currentBudgetSteps" :key="step?.id" :step="step" v-model="query.project_category_step_id" :iso="currencyIso"/>
              </div>
            </div>
            <Button v-if="$can(abilities.PROJECT_BUDGET_ALLOCATE) && mustDispactch" btnClass="btn shadow w-100" type="new" :btn-text="$t('budgets.label.dispatchByStep')"  @click.prevent="handleDispatchPress"/>
          </div>
        </Card>
    </div>
    <div class="col-md-9">
        <Card containerClass="card shadow-sm mb-5">
            <div class="card-header card-header-tabs-line card-header-stretch">
              <div class="card-toolbar">
                  <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                    <li v-if="$can(abilities.PROJECT_BUDGET_STATISTIC)" class="nav-item" @click="clickOnTab('kt_subtab_statistics')">
                        <a class="nav-link btn-active-light" :class="{'active': isActive('kt_subtab_statistics')}" data-bs-toggle="tab" href="#kt_subtab_statistics">
                          <span class="nav-icon">
                              <i class="fa fa-chart-bar fa-2x me-3"></i>
                          </span>
                          <span class="nav-text fw-bold fs-3">{{$t('budgets.stats')}}</span>
                        </a>
                    </li>
                    <li  v-if="$can(abilities.PROJECT_BUDGET_HISTORIE_TRANSACTION)" class="nav-item"  @click="clickOnTab('kt_subtab_historic')">
                        <a class="nav-link" data-bs-toggle="tab"  :class="{'active': isActive('kt_subtab_historic')}" href="#kt_subtab_historic">
                          <span class="nav-icon">
                              <i class="fa fa-history fa-2x me-3"></i>
                          </span>
                          <span class="nav-text fw-bold fs-3">{{$t('budgets.historics')}}</span>
                        </a>
                    </li>
                  
                  </ul>
              </div>
              <div class="ms-auto align-self-center" v-if="isActive('kt_subtab_historic')">
                <DateRangePicker id="stat-daterangepicker" @update:date="handleRangeDate" />
              </div>
            </div>
            <template #cardBody>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade  " :class="{'show active': isActive('kt_subtab_statistics')}" id="kt_subtab_statistics" role="tabpanel">
                  <div class="row">
                      <div class="col-md-12">
                        <div v-if="Object.values(monthStatistics.statistics)?.length">
                          <div class="col-md-12 mt-10 border-bottom pb-10">
                            <h1>{{$t('budgets.budgetStats')}}</h1>
                            <div class="row mt-5">
                                <div class="col-12 col-md-4 col-lg-4 mb-4">
                                  <StatCard 
                                    :title="$t('budgets.consumed')" 
                                    :count="monthStatistics.statistics.consumed?.percentage" 
                                    :amount="monthStatistics.statistics.consumed?.amount"
                                    color="text-warning"
                                    :iso="currencyIso"
                                    unit="%"
                                  />
                                </div>
                                <div class="col-12 col-md-4 col-lg-4 mb-4">
                                  <StatCard 
                                    :title="$t('budgets.remaining')" 
                                    :count="monthStatistics.statistics.remaining?.percentage" 
                                    :amount="monthStatistics.statistics.remaining?.amount"
                                    color="text-success"
                                    :iso="currencyIso"
                                    unit="%"
                                  />
                                </div>
                                <div class="col-12 col-md-4 col-lg-4 mb-4">
                                  <StatCard 
                                    :title="$t('budgets.overflow')" 
                                    :count="monthStatistics.statistics.deficit?.percentage" 
                                    :amount="monthStatistics.statistics.deficit?.amount"
                                    color="text-danger"
                                    :iso="currencyIso"
                                    unit="%"
                                  />
                                </div>
                            </div>
                          </div>
                          <div class="col-md-12 mt-10 border-bottom pb-10">
                            <h1>{{$t('budgets.transactionStats')}}</h1>
                            <div class="row mt-5">
                              <div class="col-12 col-md-6 col-lg-4 mb-4">
                                <StatCard 
                                    :title="$t('budgets.deposits')" 
                                    :count="monthStatistics.statistics.deposits?.deposits_number" 
                                    :amount="monthStatistics.statistics.deposits?.deposits_value"
                                    color="text-success"
                                    :iso="monthStatistics.currency_iso"
                                  />
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mb-4">
                                  <StatCard 
                                    :title="$t('budgets.withdrawals')" 
                                    :count="monthStatistics.statistics.debits?.debits_number" 
                                    :amount="monthStatistics.statistics.debits?.debits_value"
                                    color="text-danger"
                                    :iso="monthStatistics.currency_iso"
                                  />
                                </div>
                            </div>
                          </div>
                        </div>

                        <div id="kt_charts_widget_1_chart"></div>
                      
                      </div>
                  </div>
                </div>
                <div class="tab-pane fade" :class="{'show active': isActive('kt_subtab_historic')}" id="kt_subtab_historic" role="tabpanel">
                  <div v-if="false" class="row">
                      <div class="form-group col-7">
                      <div class="input-group">
                          <div class="input-group-prepend">
                          <button type="submit" title="Download resume" class="btn btn-primary font-weight-bold" :class="{'spinner spinner-left spinner-dark pl-15':isLoading }" :disabled="isLoading">
                              <i class="flaticon-download"></i>
                          </button>
                          </div>
                      </div>
                      </div>
                      <div class="form-group col-5" style="float: right;">
                      </div>
                  </div>
                  <div class="table-responsive tableFixHead">
                      <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" style="margin-top: 13px !important; cursor:pointer">
                      <thead>
                          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                          <th width="30%" class="text-center d-none d-md-table-cell" scope="col">{{$t('budgets.date')}}</th>
                          <th width="30%" class="text-center d-none d-md-table-cell" scope="col">{{$t('budgets.step')}}</th>
                          <th width="30%" class="text-center d-none d-md-table-cell" scope="col">{{$t('budgets.description')}}</th>
                          <th width="30%" class="text-center" scope="col">{{$t('budgets.debit')}}</th>
                          <th width="30%" class="text-center" scope="col">{{$t('budgets.credit')}}</th> 
                          <th class="text-center" scope="col">{{$t('budgets.sold')}}</th>
                          </tr>
                      </thead>
                      <tbody id="tbodyId" v-if="transactions?.length">
                          <tr @click.prevent="viewTransactionDetails(history.files)" v-for="history in reversedTransactions" :key="history?.id" style="cursor: pointer">
                          <td class="text-center d-none d-md-table-cell">{{ dateFormatter.formatSampleMyDateWithoutHour(history.created_at) }}</td>
                          <td class="text-center d-none d-md-table-cell">{{ history.project_category_step_name }}</td>
                          <td class="text-center d-none d-md-table-cell">{{ history.description }}</td>
                          <td class="text-center">
                              <span class="text-danger font-weight-boldest">{{ history?.type === 'DEBIT' ? amountFormatter.formatNumber(history.amountTotal) + ' ' + currencyIso : '' }}</span>
                          </td>
                          <td class="text-center">
                              <span class="text-success font-weight-boldest">{{ history?.type === 'CREDIT' ? amountFormatter.formatNumber(history.amountTotal) + ' ' + currencyIso : '' }}</span>
                          </td>
                          <td class="text-center">
                              <span class="font-weight-boldest">{{ amountFormatter.formatNumber(history.sold)  + ' ' + currencyIso }}</span>
                          </td>
                          </tr>
                      </tbody>
                      <div v-else>
                          <div class="text-center">
                          <div class="pt-8">
                              <Img filename="empty.png" alt="" class="mw-100 h-100px h-sm-150px" />
                          </div>
                          </div>
                      </div>
                      </table>
                  </div>
                </div>
            </div>
            </template>
        </Card>
    </div>
  </div>
  <div v-if="!currentBudget && !loading" class="justify-content-center align-items-centen">
    <Card class="card p-5 h-full">
      <div class=" text-center ">
        <div class="pt-8 ">
          <Img filename="empty.png" alt=""
              class="mw-100 h-125px h-sm-175px" />
        </div>
        <h2 class="fs-2x fw-bolder mb-0">{{ $t('budgets.label.noBudgetDefine') }}</h2>
        <br>
        <br>
        <Button v-if="$can(abilities.PROJECT_BUDGET_CREATE)" btn-class="btn-md" type="new" btn-text="budgets.label.saveBuget" @click="handleCreatePress"/>
        <br>
        <br>
        <br>
        <br>

      </div>
    </Card>
  </div>
  <DispatchBudgetModal  id="dispatch_project_budget" :form="formBudget" :iso="currencyIso ?? ''" @load="loadBudgetData"/>
  <BudgetModal  id="save_project_budget" :form="formBudget" @load="loadBudgetData"/>
  <DepositModal id="deposit_modal" @load="reloadData" />
  <WithdrawalModal id="withdrawal_modal" :withStep="currentBudget?.allow_dispatch" :steps="currentBudgetSteps" @load="reloadData" />
  <FilesAttachModal id="file_attached" :file="transactionFiles"/>

</template>


<script setup>
import abilities from "@/composables/abilities";
import {onMounted, ref, watch, defineProps} from "vue";
import Card from "@/Modules/Financial/components/Card";
import {useStore} from "vuex";
import { useRoute, useRouter } from 'vue-router';
import {formattedLocalAmount} from "@/mixins/Helpers";

import {useFormatAmount} from "@/composables/formatAmount";
import {useFormatDate} from "@/composables/formatDate";
import Img from "@/components/Img.vue";
import DepositModal from "./components/DepositModal.vue";
import WithdrawalModal from "./components/WithdrawalModal.vue";
import BudgetModal from "./components/BudgetModal.vue";
import Button from "@/components/Button.vue";
import { computed } from "vue";
import BudgetStepCard from "./components/BudgetStepCard.vue";
import DispatchBudgetModal from "./components/DispatchBudgetModal.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import StatCard from "./components/StatCard.vue";
import { useSwal } from "@/composables/useSwal";
import PageLoader from "@/components/PageLoader.vue";
import i18n from "@/plugins/i18n";
import { useI18n } from "vue-i18n";
import FilesAttachModal from "@/components/FilesAttachModal.vue";
import { useHasAbility } from "@/composables/hasAbility";

const store = useStore()
const route = useRoute()
const router = useRouter()
const {showSwal} = useSwal()
const {can} = useHasAbility()
const { t } = useI18n();


const props = defineProps({
  name: {type: String, default: ''}
})


const monthsNameBox = computed(() => 
  ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
    .map(month => t(`months.${month}`).slice(0, 3))
);

const monthNumbersBox = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])

const query = ref({
  id: route.params.id,
  startDate: "",
  endDate: "",
  type: "",
  project_category_step_id: ""
})

const currentBudget = ref(null)
const currentBudgetSteps = ref(null)
const loading = ref(false)
const transactionLoading = ref(false)
const formBudget = ref({
  id: route.params.id,
  budget_id: "",
  budget_name: '',
  forecast_budget: 0,
  currency_id: "",
  allow_dispatch: "",
  steps: []
})
const transactions = ref(null)
const transactionFiles = ref([])
const count = ref(0)
const currencyIso = ref('')

const currentMonth = ref(null)
const range = ref(null)
const monthStatistics = ref({
  currency_iso: null,
  statistics: {}
})


const xAxisRootBox = ref(null);
const mainSeriesBox = ref([]);

const amountFormatter = useFormatAmount() 
const dateFormatter = useFormatDate()

const activeSubtab = computed(() => route.query.subtab || 'kt_subtab_statistics');
const isActive = (subtabId) => activeSubtab.value === subtabId;

const reversedTransactions = computed(() => [...transactions.value].reverse());

const mustDispactch = computed(() => {
  if(currentBudget.value?.allow_dispatch){
    return currentBudgetSteps.value?.length > 0 && 
    currentBudgetSteps.value?.every(step =>  parseInt(step.forecast_budget) === 0);
  }

  return currentBudget.value?.allow_dispatch
})

watch(() => query.value, async () => {
    loadTransactionsData()
    initialiseMonthData(currentMonth.value);
    await initDateRangePicker()

}, {deep: true})

watch(() => currentMonth.value, async(newValue, oldValue) => {
  if(newValue != oldValue){
    initialiseData()
    initialiseMonthData(currentMonth.value)
  }
}) 

function clickOnTab(subtabId){
  router.replace({ query: { ...route.query, subtab: subtabId } });
}

function handleCreatePress(){
  $('#save_project_budget').modal('toggle')
}

function handleDispatchPress(){
  $('#dispatch_project_budget').modal('toggle')
}

function openDepositModal() {
  $('#deposit_modal').modal('toggle')
}

function openWithdrawalModal() {
  if(currentBudget.value.balance <= 0){
    showSwal(
        i18n.global.t('swal.noAmount'),
        i18n.global.t('swal.add_amount')
    ).then( async (result) => {
     
    })
  }else{
    $('#withdrawal_modal').modal('toggle')
  }
}

function handleRangeDate (range) {
    query.value.startDate = range.start_date
    query.value.endDate = range.end_date
}

onMounted( async () => {
 
  store.dispatch('currencies/loadCurrencies')
  store.dispatch('projects/loadBudgetTransactionType')
  reloadData()

  clickOnTab(activeSubtab.value)

})

function loadTransactionsData() {
  if(query.value.startDate && query.value.endDate){
  
    transactionLoading.value = true
     store.dispatch("projects/getBudgetTransactionHistories",query.value )
        .then((response) => {
          transactions.value = response.data.histories
          count.value = response.data.count
        })
        .catch((error) => {
        })
        .finally(() => transactionLoading.value = false)
  }
}

async function loadBudgetData() {
  loading.value = true
  try {
    const [budgetResponse, stepResponse] = await Promise.all([
      store.dispatch("projects/getProjectBudget", route.params.id),
      store.dispatch("projects/getProjectStepWithBudget", route.params.id)
    ]);

    formBudget.value = {
      budget_id: budgetResponse.data?.data?.id,
      budget_name: budgetResponse.data?.data?.name ?? props?.name,
      allow_dispatch: budgetResponse.data?.data?.allow_dispatch,
      forecast_budget: budgetResponse.data?.data?.forecast_budget,
      currency_id: budgetResponse.data?.data?.currency?.id,
      steps: stepResponse?.data?.data?.map(el => ({
        project_category_step_id: el?.id,
        project_category_step_name: el?.title,
        forecast_budget: parseInt(el?.forecast_budget)
      }))
    };

    currentBudget.value = budgetResponse.data?.data;
    currencyIso.value = budgetResponse.data?.data?.currency?.iso
    currentBudgetSteps.value = stepResponse.data?.data;

  } catch (error) {

  }finally{
    loading.value = false
  }
}




async function initialiseMonthData(current) { 
  if (current === undefined){
    current = parseInt(moment().format('M'))
  }

  let date = range.value || (query.value?.startDate ? moment(query.value.startDate).format('YYYY') : null);
  if(date && currentBudget.value) {
    let response = await store.dispatch('projects/getBudgetMonthStatistics', {
      id: route.params.id,
      year: date,
      month: current,
      project_category_step_id: query.value?.project_category_step_id
    })

    if('currency_iso' in response.data){
      monthStatistics.value = response.data
    }
  }
}


async function reloadData () {
  loadTransactionsData();
  await loadBudgetData();
  await initDateRangePicker()
}

async function initDateRangePicker(){
  var start = moment().subtract(29, "days");
  var end = moment();

  $("#kt_dashboard_daterangepicker").datepicker({
    format: "yyyy",
    startView: "years",
    minViewMode: "years",
    autoclose: true,
    maxDate: moment(new Date())
  }, cbBox);

  currentMonth.value = parseInt(moment().format('M'))

  await cbBox(start, end, '');
}

async function cbBox(start, end, label) {
  let title = '';

  let year = end.format('Y');

  range.value = year

  $('#kt_dashboard_daterangepicker_date').html(year);
  $('#kt_dashboard_daterangepicker_title').html(title);

  if(currentMonth.value){
    initialiseMonthData(currentMonth.value)
  }else {
    initialiseMonthData()
  }

  initialiseData(year)
}

async function initialiseData(range){
  let date = range || (props.filterStatBox?.start_date ? moment(props.filterStatBox?.start_date).format('YYYY') : null);
  if(currentBudget.value && date && moment(date, 'YYYY', true).isValid()) {
    let response = await store.dispatch('projects/getBudgetStatistics', {
      id: route.params.id,
      year: date,
      project_category_step_id: query.value?.project_category_step_id
    })

    let data = [];

    monthNumbersBox.value.forEach(number => {
      let information = response?.data?.statistics[number]
      if(information){
        data.push({
          "month": information.month,
          "credit": information.deposits_value,
          "debit": information.debits_value,
        })
      }
    })

    initChartBox(data, response?.data?.currency_iso)
  }
}

function initChartBox(dataSeries) {
  if(!xAxisRootBox.value && !mainSeriesBox.value.length) {
    am5.ready(() => {

      var root = am5.Root.new("kt_charts_widget_1_chart", {
        panX: "none",
        panY: "none",
        maxZoomLevel: 1
      });

      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      var chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        paddingLeft: 0,
        wheelX: "none",
        wheelY: "none",
        layout: root.verticalLayout
      }));

      var legend = chart.children.push(
          am5.Legend.new(root, {
            centerX: am5.p50,
            x: am5.p50
          })
      );

      var data = dataSeries


      var xRenderer = am5xy.AxisRendererX.new(root, {
        cellStartLocation: 0.1,
        cellEndLocation: 0.9,
        minorGridEnabled: true,
        minGridDistance: 30
      })

      var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: "month",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {})
      }));

      xAxisRootBox.value = xAxis

      xRenderer.grid.template.setAll({
        location: 1
      })

      xAxis.data.setAll(data);

      var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {
          strokeOpacity: 0.1
        })
      }));

      const makeSeries = (name, fieldName, color) => {
        var series = chart.series.push(am5xy.ColumnSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: fieldName,
          categoryXField: "month",
        }));

        series.columns.template.setAll({
          tooltipText: "{name}, {categoryX}:{valueY}",
          width: am5.percent(90),
          tooltipY: 0,
          strokeOpacity: 0,
        });

        series.data.setAll(data);

        series.appear();

        series.bullets.push(function () {
          return am5.Bullet.new(root, {
            locationY: 0,
            sprite: am5.Label.new(root, {
              text: "{valueY}",
              fill: root.interfaceColors.get("alternativeText"),
              centerY: 0,
              centerX: am5.p50,
              populateText: true
            })
          });
        });

        legend.data.push(series);

        series.columns.template.setAll({
          fill: am5.color(color), stroke: am5.color(color),
          maxWidth: 10
        });

        mainSeriesBox.value[fieldName] = series
      }

      makeSeries(t("budgets.credit"), "credit", 0x2DA333);
      makeSeries(t("budgets.debit"), "debit", 0xF64E60);
    });
  }else {
    xAxisRootBox.value.data.setAll(dataSeries);
    mainSeriesBox.value['credit'].data.setAll(dataSeries);
    mainSeriesBox.value['debit'].data.setAll(dataSeries);
  }
}

async function viewTransactionDetails(files){
  if(can(abilities.PROJECT_BUDGET_TRANSACTION_VIEW)){
    transactionFiles.value = files?.map(el => ({name: el?.file, url: el?.file_url}))
    $('#file_attached').modal('toggle')
  }
}

</script>


<style scoped>

#kt_charts_widget_1_chart {
  width: 100%;
  height: 400px;
}

.tableFixHead {
  table-layout: fixed;
  border-collapse: collapse;
}


.tableFixHead thead tr {
  display: block;
}

.tableFixHead th,
.tableFixHead  td {
  padding: 5px 10px;
  width: 200px;
}

tbody::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

tbody::-webkit-scrollbar
{
  width: 12px;
  background-color: #F5F5F5;
}

tbody::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #bcbaba;
}
tbody {
  height: calc(100vh - 350px) !important;
}

tbody tr{
  height: auto !important;
}

tbody{
  flex: 1 1 auto;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}

</style> 
